import {Directive, ElementRef, inject, output} from '@angular/core';

@Directive({
    selector: '[xuiInteractiveTextField]',
    host: {
      '(keyup)': 'onKeyup($event)',
      '(paste)': 'onPaste($event)'
    }
})
export class InteractiveTextFieldDirective {
  private elementRef = inject(ElementRef);

  readonly valueChanges = output<string>();

  onKeyup(_event: KeyboardEvent) {
    const value = this.elementRef.nativeElement.value;
    this.valueChanges.emit(value);
  }

  onPaste(_event: ClipboardEvent) {
    const value = this.elementRef.nativeElement.value;
    this.valueChanges.emit(value);
  }
}
